import { AxiosError } from 'axios';

export const isAxiosError = (candidate: unknown): candidate is AxiosError => {
    return (candidate as AxiosError).isAxiosError === true;
};
